import { getFundLipperRating } from '../../api/fund.api';
import { FundLipperRatingData } from '../../types/fundsummary.type';
import useFundResource, { FundResourceResult } from './useFundResource';

const useFundLipperRating = (
  ric: string = '',
  token: string = '',
  saleInCountryCode: string = 'US',
): FundResourceResult<FundLipperRatingData> =>
  useFundResource<FundLipperRatingData>(
    getFundLipperRating,
    ric,
    token,
    saleInCountryCode,
  );

export default useFundLipperRating;
